<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات دسته بندی تور"
        >
          <b-form
              ref="tourcategoryform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2 form-size"
                  md="8"
              >

                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="7">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="5">
                          <b-form-group
                              label="دسته بندی والد"
                              label-for="TourCategoryId"
                          >
                            <z-tour-category
                                v-model="Form.TourCategoryId"
                                :multiple="false"
                                :clearable="true"
                            />
                          </b-form-group>
                        </b-col>

                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="پیوند یکتا"
                        label-for="Slug"
                    >
                      <b-form-input
                          id="Sort"
                          v-model="Form.Slug"
                          name="Slug"
                          autocomplete="off"
                          dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">

                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                          class="divider-text"
                          style="font-weight: 600;"
                      >
                        نظرات
                      </div>
                    </div>
                  </b-col>

                  <template
                      v-for="(item, index) in Form.TourCategoryComment"
                  >
                    <b-col md="5">
                      <b-form-group label="نام نویسنده">
                        <b-form-input
                            v-model="item.Author"
                            autocomplete="off"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group label="امتیاز">
                        <v-select
                            v-model="item.Rating"
                            :options="[1, 2, 3, 4, 5]"
                            dir="rtl"
                            :clearable="false"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group label="تاریخ">
                        <date-picker
                            v-model="item.Date"
                            placeholder=""
                            format="YYYY-MM-DD"
                            :clearable="true"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="11">
                      <b-form-group label="متن نظر">
                        <b-form-textarea
                            v-model="item.Text"
                            rows="2"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col
                        md="1"
                        class="d-flex align-items-center"
                    >
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-danger"
                          class="btn-icon"
                          @click="removeTourCategoryComment(index)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-col>

                    <b-col cols="12">
                      <div class="divider divider-solid" />
                    </b-col>
                  </template>

                  <b-col class="mb-2">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="gradient-info"
                        @click="addTourCategoryComment"
                    >
                      <feather-icon
                          icon="PlusIcon"
                          class="mr-25"
                      />
                      <span>افزودن نظر</span>
                    </b-button>
                  </b-col>

                </b-row>

                <b-row>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZTourCategory from '@/tools/tourcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ProductCategoryDetails',
  components: { ZSeo, ZQuillEditor, ZTourCategory },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        Sort: 0,
        TourCategoryComment: [],
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.tourcategory.add
      if (this.$route.params.id) {
        url = this.$api.tourcategory.update
      }

      const formData = new FormData(this.$refs.tourcategoryform)
      formData.append('Id', this.Form.Id)

      if (this.Form.Video instanceof File) {
        formData.append('Video', this.Form.Video)
      }

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.TourCategoryId) {
        formData.append('TourCategoryId', this.Form.TourCategoryId)
      }

      const comments = (this.Form.TourCategoryComment || [])
          .filter(item => item.Author || item.Text)
          .map(item => ({
            Author: item.Author,
            Text: item.Text,
            Rating: item.Rating || 0,
            Date: item.Date ? this.$moment(item.Date).format('YYYY-MM-DD') : null,
          }))

      comments.forEach((item, index) => {
        formData.append(`TourCategoryComment[${index}].Author`, item.Author ?? '')
        formData.append(`TourCategoryComment[${index}].Text`, item.Text ?? '')
        formData.append(`TourCategoryComment[${index}].Rating`, item.Rating)
        if (item.Date) {
          formData.append(`TourCategoryComment[${index}].Date`, item.Date)
        }
      })

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    sliderImageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.SliderImage = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.tourcategory.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.Form.TourCategoryComment = (this.Form.TourCategoryComment || []).map(item => ({
              Author: item.Author,
              Text: item.Text,
              Rating: item.Rating,
              Date: item.Date,
            }))
          })
    },
    addTourCategoryComment() {
      if (!this.Form.TourCategoryComment) {
        this.$set(this.Form, 'TourCategoryComment', [])
      }
      this.Form.TourCategoryComment.push({
        Author: null, Text: null, Rating: 5, Date: null,
      })
    },
    removeTourCategoryComment(index) {
      this.Form.TourCategoryComment.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}

.image .form-group {
  margin-bottom: 0px;
}

.slider .media-body {
  align-self: flex-end;
}

.slider .form-group {
  margin-bottom: 0px;
}
</style>
